'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

/** Record */


/** Exported types */
var Language = (0, _immutable.Record)({
    title: '',
    id: '',
    url: ''
});

/**
 * Transforms a Squiz language definition to a data model
 * @param {LanguageType} lang The squiz language being transformed
 * @returns {LanguageRecordType} The data model
 */

var langToDataModel = function langToDataModel(_ref) {
    var title = _ref.title,
        id = _ref.id,
        url = _ref.url;
    return new Language({
        title: title,
        id: id,
        url: url
    });
};

/**
 * Converts a single product to a data model
 * @param {RawResponseType} langs The language data as provided by CMS
 * @returns {LanguageMapType} An immutable array of language records
 */
var transformLanguagesData = function transformLanguagesData() {
    var langs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { locales: [] };

    var result = (0, _immutable.Map)({
        result: (0, _immutable.List)(),
        entities: (0, _immutable.Map)({
            languages: (0, _immutable.Map)()
        })
    });

    if (langs && langs.locales) {
        return langs.locales.reduce(function (bag, locale) {
            return bag.updateIn(['result'], (0, _immutable.List)(), function (res) {
                return res.push(locale.id);
            }).setIn(['entities', 'languages', locale.id], langToDataModel(locale));
        }, result);
    }

    return result;
};

exports.default = transformLanguagesData;
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/languages/model.js
// module id = 254
// module chunks = 0